export const PROVIDER_STATUS_PAGES = {
  openai: "https://status.openai.com/",
  elevenlabs: "https://status.elevenlabs.io/",
  did: "https://status.d-id.com/",
  heygen: "https://status.heygen.com/",
  liveavatar: "https://status.heygen.com/",
  falai: "https://status.fal.ai/"
} as const;

export type StatusProvider = keyof typeof PROVIDER_STATUS_PAGES;

export type ProviderComponentState =
  | "operational"
  | "degraded_performance"
  | "partial_outage"
  | "major_outage"
  | "under_maintenance";

export interface ProviderStatusComponent {
  id: string;
  name: string;
  status: ProviderComponentState;
}

export interface ProviderStatus {
  state: "operational" | "degraded" | "outage" | "maintenance" | "unknown";
  freshness: "current" | "stale" | "unavailable";
  checkedAt: string;
  lastSuccessfulAt: string | null;
  components: ProviderStatusComponent[];
}
